import Element from "./element";

export default class Popup extends Element {
	constructor(props = {}) {
		super(props);

		this.$close = null;
	}

	init() {
		this.$close = this.$root.querySelectorAll('[data-popup="close"]');
		this.$close.forEach(($close) => {
			$close.addEventListener('click', this.hide.bind(this));
		});
	}

	show() {
		this.$root.style.display = null;
		setTimeout(() => {
			this.$root.classList.add('-show');
		}, 20);
	}

	hide() {
		this.$root.classList.remove('-show');
	}
}